import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatAttachmentDefaultVariants = {}
const chatAttachmentCompoundVariants = []

const chatAttachmentSlotNames = [
  [
    "root",
    "chatAttachment__root"
  ],
  [
    "thumb",
    "chatAttachment__thumb"
  ],
  [
    "overlay",
    "chatAttachment__overlay"
  ]
]
const chatAttachmentSlotFns = /* @__PURE__ */ chatAttachmentSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatAttachmentDefaultVariants, getSlotCompoundVariant(chatAttachmentCompoundVariants, slotName))])

const chatAttachmentFn = memo((props = {}) => {
  return Object.fromEntries(chatAttachmentSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatAttachmentVariantKeys = [
  "status"
]
const getVariantProps = (variants) => ({ ...chatAttachmentDefaultVariants, ...compact(variants) })

export const chatAttachment = /* @__PURE__ */ Object.assign(chatAttachmentFn, {
  __recipe__: false,
  __name__: 'chatAttachment',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatAttachmentVariantKeys,
  variantMap: {
  "status": [
    "uploading",
    "error"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chatAttachmentVariantKeys)
  },
  getVariantProps
})